import { cva } from 'class-variance-authority';

export const INPUT_VARIANTS = cva(
  'w-full min-w-0 rounded-xs border outline-none text-neutral-9 bg-neutral-0 placeholder:text-neutral-6 transition-colors disabled:cursor-not-allowed font-medium dark:bg-neutral-10 dark:border-neutral-9 dark:text-neutral-0 dark:placeholder:text-neutral-7',
  {
    variants: {
      size: {
        sm: 'h-8 px-3 text-body-xs',
        default: 'h-10 px-4 text-body-sm',
        lg: 'h-12 px-4 text-body-base',
      },
      variant: {
        default:
          'border-neutral-4 hover:border-neutral-6 focus-visible:border-primary-base dark:border-neutral-9 dark:hover:border-neutral-8 dark:focus-visible:border-primary-base',
        error:
          '!border-semantic-error-base !hover:border-semantic-error-base !focus-visible:border-semantic-error-base',
      },
      disabled: {
        true: 'pointer-events-none border-neutral-4 !text-neutral-6 bg-neutral-2 dark:border-neutral-8 dark:!text-neutral-7 dark:bg-neutral-9',
      },
    },
    defaultVariants: {
      size: 'default',
      variant: 'default',
      disabled: false,
    },
  },
);

export const LABEL_VARIANTS = cva('font-semibold', {
  variants: {
    size: {
      sm: '!text-body-xs',
      default: '!text-body-sm',
      lg: '!text-body-base',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export const ICON_VARIANTS = cva('inline-flex items-center', {
  variants: {
    size: {
      sm: 'size-4',
      default: 'size-5',
      lg: 'size-6',
    },
  },
});

export const INPUT_PREFIX_PADDING_VARIANTS = cva('', {
  variants: {
    size: {
      sm: 'pl-10',
      default: 'pl-11',
      lg: 'pl-12',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export const INPUT_POSTFIX_PADDING_VARIANTS = cva('', {
  variants: {
    size: {
      sm: 'pr-10',
      default: 'pr-11',
      lg: 'pr-12',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});
